export default [
    { key: 'id', label: 'ID' },
    { key: 'type', label: 'Tipo' },
    { key: 'user.name', label: 'Escolta' },
    { key: 'start_date', label: 'Fecha de inicio' },
    { key: 'end_date', label: 'Fecha de terminación' },
    { key: 'city.name', label: 'Ciudad' },
    { key: 'plate_document', label: 'Placa / Documento' },
    { key: 'driver_person_name', label: 'Nombre cliente' },
    { key: 'client_customer', label: 'Sub Cliente', orderBy: 'client_customer.name' },
    { key: 'out_of_city', label: 'Fuera de la ciudad' },
    { key: 'town', label: 'Lugar', orderBy: 'towns.name' },
    { key: 'actions', label: '' },
]